module.exports = __webpack_public_path__ + "4fee82882db58de055f7ad7fe461e234.webp";